import type { Channel } from '../types';

/**
 * Server channels have a predictable rail order: personal pins first, then
 * channel names, then ids. The final id comparison makes equal names stable
 * across clients and reloads without persisting manual positions.
 */
export function sortServerChannels(
  channels: Channel[],
  isPinned: (channelId: string) => boolean,
): Channel[] {
  return [...channels].sort((left, right) => {
    const pinOrder = Number(isPinned(right.id)) - Number(isPinned(left.id));
    if (pinOrder !== 0) return pinOrder;

    const nameOrder = left.name.localeCompare(right.name, undefined, {
      sensitivity: 'base',
      numeric: true,
    });
    if (nameOrder !== 0) return nameOrder;
    return left.id.localeCompare(right.id);
  });
}
